var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubwallet = function SvgSubwallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 100,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#subwallet_svg__a)",
    d: "M66 36.1V22.2L11 0 0 5.6v43.1l41.8 16.7-22.2 9.5v-7.3L9.4 63.4 0 67.8v26.4l11 5.6 55-25V57L16.8 37.1V24.9l39.6 15.9 9.6-4.7Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "subwallet_svg__a",
    x1: 0,
    x2: 90.967,
    y1: 0,
    y2: 59.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#61FEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0425FE"
  })))));
};
export default SvgSubwallet;